import * as React from 'react';
import {CircularProgressbar, buildStyles} from "react-circular-progressbar";
  import "react-circular-progressbar/dist/styles.css";


interface LeadCircularProgressComponentProps {
    value: any,
    leadQualityScoreType: any,
}

const LeadCircularProgressComponent: React.FC<LeadCircularProgressComponentProps> = ({ value, leadQualityScoreType }) => {
    const [progress, setProgress] = React.useState(0);
    React.useEffect(() => {
        // console.log("leadQualityScoreType",leadQualityScoreType)
        setProgress(value)
    }, [value])

    return <CircularProgressbar
        value={progress}
        text={`${progress}%`}
        strokeWidth={8}
        styles={buildStyles({
            textSize: '24px',
            textColor: '#303030',
            pathColor: (leadQualityScoreType === "good") ? "#279f9f" : (leadQualityScoreType === "moderate") ? "#ffc72c" : (leadQualityScoreType === "poor") ? "#f39898" : "#279f9f",
            pathTransitionDuration: 1,
        })
    }
    />
}

export default LeadCircularProgressComponent
